import { createFileRoute } from '@tanstack/react-router'
import { AirportDirectory } from '@/components/AirportDirectory'
import { z } from 'zod'

const airportDirectorySearchSchema = z.object({
  search: z.string().optional(),
})

export const Route = createFileRoute('/_auth/airport-directory/')({
  validateSearch: airportDirectorySearchSchema,
  component: AirportDirectoryRoute,
})

function AirportDirectoryRoute() {
  const { search } = Route.useSearch()

  return <AirportDirectory initialSearch={search} />
}
